// extracted by mini-css-extract-plugin
export default {"contenedor-redes-sociales":"RedesSociales_contenedor-redes-sociales__+bZfH"};